import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ColumnType } from '@datachain/ui-sdk/components/dc-types';
import {
	FieldConfig,
	QueryBuilderGroupConfig,
	QueryBuilderRulesConfig,
	QueryRuleBuilder,
	RuleFieldCategory,
	RuleFieldType,
} from '@datachain/ui-sdk/components/query-builder';
import { Map } from 'immutable';

import { ColumnConfigItemEntity } from '../../../domain/column-config-item.entity';

// const createRuleConfig = (field: FieldConfig): QueryBuilderRulesConfig => ({
// 	id: field.id,
// 	label: field.label,
// 	type: field.type,
// 	primaryValue: '',
// });

@Injectable()
export class ColumnsQueryFieldsProvider {
	private ruleBuilder: QueryRuleBuilder | null = null;

	public convertToQueryBuilderField(
		cols: Map<string, ColumnConfigItemEntity>
	): Array<FieldConfig> {
		return cols
			.toList()
			.toArray()
			.map<FieldConfig>((col) => {
				const { type, category } = this.parseColType(col.columnType);
				return {
					id: col.id,
					label: col.alias,
					type,
					category,
				};
			});
	}

	public createInitialQueryBuilderForm(fields: Array<FieldConfig>): FormGroup {
		if (!this.ruleBuilder) {
			this.ruleBuilder = new QueryRuleBuilder(fields);
		}
		return this.ruleBuilder.createSimpleGroup('or', []);
	}

	public populateQueryBuilderForm(
		root: QueryBuilderGroupConfig,
		fields: Array<FieldConfig>
	): FormGroup {
		if (!this.ruleBuilder) {
			this.ruleBuilder = new QueryRuleBuilder(fields);
		}
		return this.ruleBuilder.buildFromConfig(root);
	}

	private parseColType(colType: ColumnType): {
		type: `${RuleFieldType}`;
		category: `${RuleFieldCategory}`;
	} {
		if (colType === ColumnType.Bool) {
			return {
				type: 'boolean',
				category: 'basic',
			};
		}
		if (colType === ColumnType.Str) {
			return {
				type: 'string',
				category: 'basic',
			};
		}
		if (colType === ColumnType.Words) {
			return {
				type: 'string',
				category: 'word',
			};
		}
		if (colType === ColumnType.Date) {
			return {
				type: 'dateTime',
				category: 'basic',
			};
		}
		if (colType === ColumnType.Int) {
			return {
				type: 'number',
				category: 'integer',
			};
		}
		if (colType === ColumnType.BigInt) {
			return {
				type: 'number',
				category: 'bigInteger',
			};
		}
		if (colType === ColumnType.Dec) {
			return {
				type: 'number',
				category: 'decimal',
			};
		}
		if (colType === ColumnType.Double) {
			return {
				type: 'number',
				category: 'double',
			};
		}

		return {
			type: 'string',
			category: 'basic',
		};
	}
}
